import * as React from 'react'
import {
	Avatar,
	AvatarImage,
	AvatarFallback,
} from '#app/components/ui/avatar.tsx'

export function DomainFavicon({
	domain,
	size = 16,
	className,
}: DomainFaviconProps) {
	const hostname = toHostname(domain)
	const [loaded, setLoaded] = React.useState(false)
	const src = hostname
		? `/resources/favicon?domain=${encodeURIComponent(hostname)}&sz=${size}`
		: ''
	const letter =
		hostname
			.replace(/^www\./, '')
			.toUpperCase()
			.charAt(0) || '•'
	const fontSize = Math.max(10, Math.floor(size * 0.6))

	return (
		<Avatar className={className} style={{ width: size, height: size }}>
			{hostname ? (
				<AvatarImage
					src={src}
					alt=""
					loading="lazy"
					decoding="async"
					referrerPolicy="no-referrer"
					style={{
						display: loaded ? 'block' : 'none',
						width: size,
						height: size,
					}}
					onLoad={() => setLoaded(true)}
					onError={() => setLoaded(false)}
				/>
			) : null}
			{!loaded && (
				<AvatarFallback
					className="leading-none"
					style={{ fontSize }}
					aria-hidden="true"
				>
					{letter}
				</AvatarFallback>
			)}
		</Avatar>
	)
}

function toHostname(input: string): string {
	if (!input) return ''
	try {
		const hasProto = input.includes('://')
		return new URL(hasProto ? input : `https://${input}`).hostname
	} catch {
		return input
	}
}

interface DomainFaviconProps {
	domain: string
	size?: number
	className?: string
}
